export default __webpack_public_path__ + "static/media/add_user.16552d7c.png";